<template>
    <div>
        <DxTaskPopup :drag-enabled="false"
                     :show-title="true"
                     :title="popupTitle"
                     :close-on-outside-click="false"
                     :show-close-button="true"
                     :on-hidden="popupOnHidden"
                     ref="taskPopup"
                     :on-shown="popupOnShown"
                     class="task-popup"
                     titleTemplate="title"
                     container="#app">
            <template #title>
                <div class="dx-toolbar dx-widget dx-visibility-change-handler dx-collection dx-popup-title dx-has-close-button" role="toolbar">
                    <div class="task-toolbar-items-container">
                        <div class="task-toolbar-before" v-html="popupTitle"></div>
                        <div class="task-toolbar-after">
                            <div class="dx-button dx-button-normal dx-button-mode-text dx-widget dx-button-has-icon dx-button-bug" aria-label="close" tabindex="0" role="button" @click="onClickBugReport">
                                <div class="dx-button-content">
                                    <div :class="['bug-report', bugReportSpinnerActive ? 'spinner' : '']">
                                        <i class="dx-icon iconset bug_report"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="dx-button dx-button-normal dx-button-mode-text dx-widget dx-button-has-icon" aria-label="close" tabindex="0" role="button" @click="hidePopup">
                                <div class="dx-button-content"><i class="dx-icon dx-icon-close"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <DxPosition at="center"
                        my="center"
                        v-model:of="positionOf" />

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="after"
                           :options="closeButtonOptions" />

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="after"
                           :options="saveButtonOptions"
                           :visible="popupMode=='insert'" />

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="before"
                           :options="issueButtonOptions"
                           :visible="popupMode=='sEditor'" />

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="before"
                           :options="developmentButtonOptions"
                           :visible="popupMode=='sEditor'" />

            <template #content>

                <div id="task-popup-content-wrapper">
                    <div class="task-popup-header mb-4" v-show="popupMode=='sEditor'">
                        <div>
                            <h3>Képernyőkép szerkesztése</h3>
                        </div>
                        <div>{{createdDate}}</div>
                    </div>

                    <div class="task-popup-header mb-4" v-show="false && popupMode!='sEditor' && popupMode!='chooseAfterScreenshot'">
                        <div style="flex-grow: 1; margin-right: 10px; align-self: safe center;">
                            <h3>{{taskTypeText}}</h3>
                        </div>
                        <div class="created-date" style="flex-grow: 2; margin-right: 10px; align-self: safe center;">{{createdDate}}</div>
                    </div>

                    <div v-show="popupMode=='chooseAfterScreenshot'">
                        <div class="choose-text">
                            <p>A gomb megnyomásának hatására készítettünk egy képernyőképet, ezt a képernyőképet csatolhatja új vagy már meglévő hibabejelentéséhez, továbbfejlesztési javaslatához.</p>
                        </div>
                        <div class="choose-buttons">
                            <div class="choose-button">
                                <DxButton text="Új hibabejelentés"
                                          type="normal"
                                          styling-mode="contained"
                                          @click="chooseAction('newBugreport')"
                                          width="100%" />
                            </div>
                            <div class="choose-button">
                                <DxButton text="Új továbbfejlesztési javaslat"
                                          type="normal"
                                          styling-mode="contained"
                                          @click="chooseAction('newImprovementProposals')"
                                          width="100%" />
                            </div>
                            <div class="choose-button">
                                <DxButton text="Képernyőkép csatolása meglévő hibabejelentéshez"
                                          type="normal"
                                          styling-mode="contained"
                                          @click="chooseAction('addScreenshotToBugreport')"
                                          width="100%" />
                            </div>
                            <div class="choose-button">
                                <DxButton text="Képernyőkép csatolása meglévő továbbfejlesztési javaslathoz"
                                          type="normal"
                                          styling-mode="contained"
                                          @click="chooseAction('addScreenshotToImprovementProposal')"
                                          width="100%" />
                            </div>
                            <div class="choose-button">
                                <DxButton text="Ugrás a fejlesztési naplóba"
                                          type="normal"
                                          styling-mode="contained"
                                          @click="chooseAction('showDevelopmentDiary')"
                                          width="100%" />
                            </div>
                        </div>
                    </div>

                    <DxScrollView class="popup-content-scrollview" width="100%" height="100%" v-show="popupMode=='view' || popupMode=='insert' || popupMode=='edit'" ref="formScrollView" show-scrollbar="always">
                        <template>
                            <div v-if="false">
                                <p>vue-json-editor</p>
                                <vue-json-editor v-model="json" :show-btns="true" :expandedOnStart="true" @json-change="onJsonChange"></vue-json-editor>
                            </div>
                            <form :id="formRefName"
                                  :ref="formRefName"
                                  method="post"
                                  action=""
                                  enctype="multipart/form-data"
                                  class="form" v-show="popupMode=='insert' || popupMode=='edit'">
                                <div class="dx-fieldset popup-fieldset">
                                    <div class="fields-container">
                                        <div class="dx-field">
                                            <div class="dx-field-label" v-show="false">Megnevezés</div>
                                            <div class="dx-field-value">
                                                <DxValidationGroup ref="taskValidationGroup" v-show="popupMode=='insert'">
                                                    <DxTextBox data-field="Name"
                                                               v-model="formModel.Name"
                                                               placeholder="Megnevezés"
                                                               :read-only="popupMode=='view'">
                                                        <DxValidator>
                                                            <DxRequiredRule message="A megnevezés megadása kötelező" />
                                                        </DxValidator>
                                                    </DxTextBox>
                                                </DxValidationGroup>
                                                <h3 v-show="popupMode!='insert'">{{ formModel.Name }}</h3>
                                            </div>
                                        </div>
                                        <div class="task-screenshot-box" v-show="taskPrintScreen.length > 0">
                                            <div class="flex-container">
                                                <div class="label">Képernyőkép</div>
                                                <div class="created-date">{{createdDate}}</div>
                                            </div>
                                            <img :src="taskPrintScreen" style="max-width: 100%; height: auto; border: 2px solid #0094ff;" />
                                        </div>
                                        <div class="diagnostics-data" v-if="false && firstComment && firstComment.diagnosticsData">
                                            <div class="flex-container">
                                                <div class="label">Diagnosztikai adatok</div>
                                                <div class="created-date">{{createdDate}}</div>
                                            </div>
                                            <vue-json-editor :value="JSON.parse(firstComment.diagnosticsData)" mode="form" :show-btns="false" :expandedOnStart="false" @json-change="onJsonChange"></vue-json-editor>
                                        </div>
                                        <div class="task-screenshot-box" v-show="popupMode=='insert' && currentDiagnosticsData">
                                            <div class="flex-container screenshot-editor-header">
                                                <div class="label">Képernyőkép szerkesztése <a class="dx-link dx-button dx-button-normal dx-button-mode-contained btn-delete-screenshot" title="Képernyőkép törlése" @click="showConfirmPopup()"><i class="dx-icon-close dx-link-icon"></i></a></div>
                                                <div class="created-date">{{ dateTimeFormatter(latestScreenshotDateTime) }}</div>
                                            </div>
                                            <div class="screenshot-editor-wrapper">
                                                <DxScrollView width="100%" height="200%" class="screenshot-editor-wrapper">
                                                    <ScreenshotEditor :ref="sEditorRefName" ed-ref-name="ed01" />
                                                </DxScrollView>
                                            </div>
                                        </div>
                                        <div class="dx-field" v-show="popupMode=='insert' || (formModel.Description && formModel.Description.length > 0)">
                                            <div class="dx-field-label" v-show="false">Leírás</div>
                                            <div class="dx-field-value">
                                                <DxTextArea :min-height="84"
                                                            :auto-resize-enabled="true"
                                                            data-field="Description"
                                                            :read-only="popupMode=='view'"
                                                            placeholder="Leírás"
                                                            v-model="formModel.Description"
                                                            v-show="popupMode=='insert'" />
                                                <div v-show="popupMode!='insert'" v-html="replaceNewlineToBr(formModel.Description)"></div>
                                            </div>
                                        </div>
                                        <div class="flex-container">
                                            <div class="dx-field" v-show="false" style="flex-grow: 1;">
                                                <div class="dx-field-label">Státusz</div>
                                                <div class="dx-field-value">
                                                    <DxSelectBox :search-enabled="true"
                                                                 :data-source="TaskStatusData"
                                                                 data-field="Status"
                                                                 display-expr="name"
                                                                 value-expr="id"
                                                                 :read-only="popupMode=='insert' || popupMode=='view'"
                                                                 v-model="formModel.Status" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dx-field" v-show="false">
                                            <div class="dx-field-label">Típus</div>
                                            <div class="dx-field-value">
                                                <DxSelectBox :search-enabled="true"
                                                             :data-source="TaskTypeData"
                                                             data-field="Type"
                                                             display-expr="name"
                                                             value-expr="id"
                                                             :read-only="insertFromScreenshot || popupMode=='view' || popupMode=='edit'"
                                                             v-model="formModel.Type" />
                                            </div>
                                        </div>
                                        <div class="dx-field" v-show="false">
                                            <div class="dx-field-label">Létrehozás dátuma</div>
                                            <div class="dx-field-value">
                                                <DxDateBox :value="now"
                                                           data-field="Created_date"
                                                           type="date"
                                                           :read-only="true"
                                                           v-model="formModel.Created_date" />
                                            </div>
                                        </div>
                                        <div class="flex-container">
                                            <div class="dx-field" style="flex-grow: 1;" v-show="showPriorityAndDates">
                                                <div class="dx-field-label">Prioritás</div>
                                                <div class="dx-field-value">
                                                    <DxSelectBox :search-enabled="true"
                                                                 :data-source="TaskPriorityData"
                                                                 data-field="Priority"
                                                                 display-expr="name"
                                                                 value-expr="id"
                                                                 :read-only="popupMode=='view'"
                                                                 v-model="formModel.Priority" />
                                                </div>
                                            </div>
                                            <div class="dx-field" style="flex-grow: 1;" v-show="showPriorityAndDates">
                                                <div class="dx-field-label">Kezdés dátuma</div>
                                                <div class="dx-field-value">
                                                    <DxDateBox :value="now"
                                                               data-field="Start_date"
                                                               :read-only="popupMode=='view'"
                                                               type="date"
                                                               v-model="formModel.Start_date" />
                                                </div>
                                            </div>
                                            <div class="dx-field" style="flex-grow: 1;" v-show="showPriorityAndDates">
                                                <div class="dx-field-label">Befejezés dátuma</div>
                                                <div class="dx-field-value">
                                                    <DxDateBox :value="now"
                                                               data-field="End_date"
                                                               :read-only="popupMode=='view'"
                                                               type="date"
                                                               v-model="formModel.End_date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dx-fieldset popup-fieldset">

                                    <CustomDxFileUploader select-button-text="Csatolmányok hozzáadása"
                                                          label-text=""
                                                          icon="upload"
                                                          accept="fileAccept"
                                                          :multiple="fileMultiple"
                                                          upload-mode="fileUploadMode"
                                                          :ref="fileUploaderRefName"
                                                          :onOptionChanged="fileUploaderPropertyChange"
                                                          v-show="popupMode=='insert'"
                                                          id="taskFileUploader" />

                                    <div class="comment-attachment-list first-comment" v-if="(popupMode=='view' || popupMode=='edit') && firstComment">
                                        <h4 class="task-comments-title">Csatolmányok</h4>
                                        <div class="task-attachments">
                                            <div class="comment-attachment dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon" v-for="attachment in filteredAttachments(firstComment.attachments)"
                                                 :title="getAttachmentTitle(attachment)"
                                                 @click="downloadAttachment(attachment)">
                                                <div class="dx-button-content"><i :class="getAttachmentIconClass(attachment)"></i></div>
                                            </div>
                                        </div>
                                        <div class="task-attachments has-no-attachment" v-show="!firstComment.attachments || firstComment.attachments.length == 0 || (firstComment.attachments.length == 1  && taskPrintScreen.length > 0)">
                                            Nincs csatolmány
                                        </div>
                                    </div>
                                    <div class="task-footer dx-fieldset" v-show="popupMode=='edit'">
                                        <DxButton text="Módosítások mentése"
                                                  icon="save"
                                                  type="normal"
                                                  styling-mode="contained"
                                                  @click="updateTaskData" />
                                    </div>
                                </div>
                                <div id="formScrollViewBottom"></div>
                            </form>
                            <div id="task-comments" v-show="popupMode=='view' || popupMode=='edit'">
                                <div class="dx-fieldset popup-fieldset">
                                    <h4 class="task-comments-title" v-show="false">Bejegyzések</h4>
                                    <div class="task-comment-list">
                                        <div v-for="comment in filteredComments"
                                             :class="getCommentClass(comment)"
                                             :key="comment.id"
                                             :data-parent-id="comment.ParentCommentId? comment.ParentCommentId : ''">
                                            <div class="comment-header">
                                                <div class="comment-create-date">{{ formatCommentDate(comment.createdDate) }}</div>
                                                <div class="comment-created-by-name">{{ comment.createdByUser? comment.createdByUser.friendlyName : '[-]' }}</div>
                                            </div>
                                            <div class="diagnostics-data" v-if="false && comment.diagnosticsData">
                                                <div class="flex-container">
                                                    <div class="label">Diagnosztikai adatok</div>
                                                    <div class="created-date">{{ formatCommentDate(comment.screenshotDateTime) }}</div>
                                                </div>
                                                <vue-json-editor :value="JSON.parse(comment.diagnosticsData)" mode="form" :show-btns="false" :expandedOnStart="false" @json-change="onJsonChange"></vue-json-editor>
                                            </div>
                                            <div class="comment-screenshot-box" :id="'comment-screenshot-' + comment.id" v-show="getScreenshotFile(comment)">
                                                <div class="flex-container">
                                                    <div class="label">Képernyőkép</div>
                                                    <div class="created-date">{{ formatCommentDate(comment.screenshotDateTime) }}</div>
                                                </div>
                                                <img class="comment-screenshot-img" :id="'comment-screenshot-img-' + comment.id" />
                                            </div>
                                            <div class="comment-body" v-html="replaceNewlineToBr(comment.comment)"></div>
                                            <div class="comment-footer" v-show="filteredAttachments(comment.attachments).length > 0">
                                                <div class="comment-attachment-list">
                                                    <div class="comment-attachment-title">Csatolmányok:</div>
                                                    <div class="comment-attachment dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon" v-for="attachment in filteredAttachments(comment.attachments)"
                                                         :title="getAttachmentTitle(attachment)"
                                                         @click="downloadAttachment(attachment)">
                                                        <div class="dx-button-content"><i :class="getAttachmentIconClass(attachment)"></i></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="comment-screenshot-box" v-show="(popupMode=='view' || popupMode=='edit') && currentDiagnosticsData">
                                        <div class="flex-container screenshot-editor-header">
                                            <div class="label">Képernyőkép szerkesztése <a class="dx-link dx-button dx-button-normal dx-button-mode-contained btn-delete-screenshot" title="Képernyőkép törlése" @click="showConfirmPopup(true)"><i class="dx-icon-close dx-link-icon"></i></a></div>
                                            <div class="created-date">{{ dateTimeFormatter(latestScreenshotDateTime) }}</div>
                                        </div>
                                        <div class="screenshot-editor-wrapper">
                                            <DxScrollView width="100%" height="200%">
                                                <ScreenshotEditor :ref="commentSEditorRefName" ed-ref-name="ed02" />
                                            </DxScrollView>
                                        </div>
                                    </div>
                                    <div class="task-comment-form" v-show="popupMode=='view' || popupMode=='edit'">
                                        <form :id="commentFormRefName"
                                              :ref="commentFormRefName"
                                              method="post"
                                              action=""
                                              enctype="multipart/form-data"
                                              class="form">

                                            <div class="dx-fieldset-custom">
                                                <div class="dx-field">
                                                    <div class="dx-field-label comment-label" v-show="false">Új bejegyzés</div>
                                                    <div class="dx-field-value">
                                                        <DxValidationGroup ref="commentValidationGroup">
                                                            <DxTextArea :min-height="84"
                                                                        :auto-resize-enabled="true"
                                                                        data-field="Comment"
                                                                        placeholder="Bejegyezés szövege"
                                                                        v-model="commentModel.Comment">
                                                                <DxValidator>
                                                                    <DxRequiredRule message="Bejegyzés megadása kötelező" />
                                                                </DxValidator>
                                                            </DxTextArea>
                                                        </DxValidationGroup>
                                                    </div>
                                                </div>
                                                <CustomDxFileUploader select-button-text="Csatolmányok hozzáadása"
                                                                      label-text=""
                                                                      icon="upload"
                                                                      accept="fileAccept"
                                                                      :multiple="fileMultiple"
                                                                      upload-mode="fileUploadMode"
                                                                      :ref="commentFileUploaderRefName"
                                                                      :onOptionChanged="commentFileUploaderPropertyChange"
                                                                      id="commentFileUploader" />
                                                <div id="commentFormScrollViewBottom"></div>
                                            </div>
                                            <div class="dx-fieldset comment-buttons">
                                                <DxButton text="Mégse"
                                                          icon="close"
                                                          type="normal"
                                                          styling-mode="contained"
                                                          @click="resetCommentForm(true, true)"
                                                          style="margin-right: 10px"
                                                          v-show="commentFormHasAttachment || commentModel.Comment.length > 0" />
                                                <DxButton text="Bejegyzés beküldése"
                                                          icon="save"
                                                          type="normal"
                                                          styling-mode="contained"
                                                          @click="sendCommentData" />

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </DxScrollView>
                </div>
            </template>
        </DxTaskPopup>

        <CustomDxPopup ref="confirmPopup"
                       :drag-enabled="false"
                       :close-on-outside-click="true"
                       :show-close-button="true"
                       :show-title="false"
                       :width="320"
                       :height="140"
                       container="#app">

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="center"
                           :options="closeConfirmPopupButtonOptions" />

            <DxToolbarItem widget="dxButton"
                           toolbar="bottom"
                           location="center"
                           :options="deleteButtonOptions" />
            <div class="confirm-text">
                Biztos benne, hogy törli a képernyőképet?
            </div>
        </CustomDxPopup>
    </div>
</template>

<script>
    import {
        DxPopup as DxTaskPopup,
        DxPosition,
        DxToolbarItem
    } from 'devextreme-vue/popup';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import { DxForm as DxNotifierForm, DxLabel } from 'devextreme-vue/form';
    import 'devextreme-vue/text-area';
    import { DxFileUploader } from 'devextreme-vue/file-uploader';
    import DxTextBox from 'devextreme-vue/text-box';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import DxDateBox from 'devextreme-vue/date-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import DxButton from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';

    import { TaskPriority } from "../enums/TaskPriority";
    import { TaskPriorities } from "../enums/TaskPriorities";
    import { TaskStatus } from "../enums/TaskStatus";
    import { TaskType } from "../enums/TaskType";
    import { TaskTypes } from "../enums/TaskTypes";
    import { CommentTypes } from "../enums/CommentTypes";
    import ScreenshotEditor from "./ScreenshotEditor";

    import taskService from "../services/task.service";
    import taskCommentService from "../services/task-comment.service";
    import vueJsonEditor from 'vue-json-editor';
    import DxValidator, {
        DxRequiredRule,
        DxPatternRule
    } from 'devextreme-vue/validator';

    import DxValidationGroup from 'devextreme-vue/validation-group';
    import CustomDxFileUploader from "./CustomDxFileUploader";
    import CustomDxPopup from "./CustomDxPopup";

    export default {
        name: 'TaskPopup',
        props: {
            taskId: {
                type: Number,
                default: 0
            },
            mode: {
                type: String,
                default: 'insert'
            },
            type: {
                type: Number,
                default: 1 // hiba
            }
        },
        components: {
            DxTaskPopup,
            DxPosition,
            DxToolbarItem,
            DxNotifierForm,
            TaskStatus,
            TaskPriority,
            TaskType,
            TaskTypes,
            DxLabel,
            DxScrollView,
            DxFileUploader,
            DxTextBox,
            DxSelectBox,
            DxDateBox,
            DxTextArea,
            vueJsonEditor,
            DxResponsiveBox,
            DxItem,
            DxLocation,
            DxCol,
            DxRow,
            ScreenshotEditor,
            DxButton,
            DxRequiredRule,
            DxValidator,
            DxValidationGroup,
            CustomDxFileUploader,
            CustomDxPopup
        },
        data() {

            let defaultStartDate = new Date();
            let defaultEndDate = new Date();
            defaultEndDate.setDate(defaultEndDate.getDate() + 7);

            return {
                popupMode: '',
                popupOptions: {
                    choose: {
                        maxWidth: '480px',
                        maxHeight: '428px'
                    },
                    default: {
                        maxWidth: '1000px',
                        maxHeight: '100%'
                    }
                },
                isPopupVisible: false,
                positionOf: '',
                insertFromScreenshot: false,
                TaskStatusData: TaskStatus.filter((item) => item.id > 0),
                TaskPriorityData: TaskPriority.filter((item) => item.id > 0),
                TaskTypeData: TaskType.filter((item) => item.id > 0),
                form: null,
                formData: {},
                sEditorRefName: 'task-screenshot-editor',
                commentSEditorRefName: 'task-comment-screenshot-editor',
                formRefName: 'task-popup-form',
                fileUploaderRefName: 'new-task-attachment',
                commentForm: null,
                commentFormData: {},
                commentFormRefName: 'task-popup-comment-form',
                commentFileUploaderRefName: 'new-comment-attachment',
                now: new Date(),
                files: [],
                fileAccept: '*',
                fileMultiple: true,
                fileUploadMode: 'useForm',
                uploadUrl: '',
                taskPrintScreen: '',
                showNewCommentButton: false,
                formModel: {
                    Name: '',
                    Status: 1,// új
                    Priority: TaskPriorities.Medium,// közepes
                    Type: 1,// Hiba
                    Description: '',
                    Created_date: defaultStartDate,
                    Start_date: defaultStartDate,
                    End_date: defaultEndDate
                },
                defaultFormModel: {
                    Name: '',
                    Status: 1,// új
                    Priority: TaskPriorities.Medium,// közepes
                    Type: 1,// Hiba
                    Description: '',
                    Created_date: defaultStartDate,
                    Start_date: defaultStartDate,
                    End_date: defaultEndDate
                },
                commentModel: {
                    TaskId: 0,
                    Comment: '',
                    ParentCommentId: null,
                    DiagnosticsData: null
                },
                defaultCommentModel: {
                    TaskId: 0,
                    Comment: '',
                    ParentCommentId: null,
                    DiagnosticsData: null
                },
                saveButtonOptions: {
                    icon: 'save',
                    text: 'Küldés',
                    onClick: () => {
                        this.createTaskData();
                    },
                },
                newButtonButtonOptions: {
                    icon: 'add',
                    text: 'Új bejegyzés',
                    onClick: () => {
                        this.loadTask(this.task.id, 'read', 'bottom');
                    },
                },
                closeButtonOptions: {
                    text: 'Bezár',
                    icon: 'close',
                    onClick: () => {
                        this.hidePopup();
                        this.resetForm();
                    },
                },
                issueButtonOptions: {
                    icon: 'iconset bug_report',
                    text: 'Hibabejelentés',
                    onClick: () => {
                        this.taskPrintScreen = this.$refs[this.sEditorRefName].getEditor().saveImage();
                        this.formModel.Type = TaskTypes.BugReport;
                        this.popupMode = 'insert';
                        this.insertFromScreenshot = true;
                    },
                },
                developmentButtonOptions: {
                    icon: 'iconset alert_errror-ticket',
                    text: 'Továbbfejlesztési javaslat',
                    onClick: () => {
                        this.taskPrintScreen = this.$refs[this.sEditorRefName].getEditor().saveImage();
                        this.formModel.Type = TaskTypes.ImprovementProposal;
                        this.popupMode = 'insert';
                        this.insertFromScreenshot = true;
                    },
                },
                deleteButtonOptions: {
                    icon: 'trash',
                    text: 'Törlés',
                    onClick: () => {
                        this.deleteScreenshot();
                    },
                },
                closeConfirmPopupButtonOptions: {
                    text: 'Bezár',
                    onClick: () => {
                        this.confirmPopupInstance.hide();
                    },
                },
                json: {
                    msg: 'demo of jsoneditor'
                },
                task: null,
                comments: [],
                firstComment: false,
                currentUser: {
                    id: '',
                    isAdmin: false,
                    friendlyName: '',
                    userName: ''
                },
                currentDiagnosticsData: false,
                latestScreenshotDateTime: false,
                popupRenderFinished: false,
                bugReportSpinnerActive: false,
                commentFormHasAttachment: false
            }
        },
        methods: {
            popupResetToDefault() {
                let popup = this.popupInstance;

                if (popup.option('maxHeight') == this.popupOptions.choose.maxHeight) {
                    popup.option('maxHeight', this.popupOptions.default.maxHeight);
                    popup.option('maxWidth', this.popupOptions.default.maxWidth);
                }
            },
            popupOnShown(e) {
                if (!this.popupRenderFinished) {                        
                    this.popupRenderFinished = true;
                }
            },
            popupOnHidden(e) {
                this.popupResetToDefault();
            },
            resetForm() {

                if (!this.form) {
                    this.form = document.getElementById(this.formRefName);
                }

                let fileUploader = this.getFileUploader();
                if (fileUploader) {
                    fileUploader.reset();
                }

                for (var key in this.defaultFormModel) {
                    this.formModel[key] = this.defaultFormModel[key];
                }

                this.taskPrintScreen = '';
                this.popupMode = 'insert';
                this.insertFromScreenshot = false;
                this.task = null;
                this.comments = [];
                this.firstComment = false;
                this.showNewCommentButton = false;
                let validator = this.$refs['taskValidationGroup'] ? this.$refs['taskValidationGroup'].instance : false;
                if (validator) {
                    validator.reset();
                }

                this.resetCommentForm();
            },
            resetCommentForm(exceptTaskId, resetDiagnosticData) {

                let fileUploader = this.getCommentFileUploader();
                if (fileUploader) {
                    fileUploader.reset();
                }

                for (var key in this.defaultCommentModel) {
                    if (exceptTaskId === true && key == 'TaskId') {
                        continue;
                    }
                    this.commentModel[key] = this.defaultCommentModel[key];
                }

                if (resetDiagnosticData && this.currentDiagnosticsData) {
                    this.currentDiagnosticsData = false;
                    this.latestScreenshotDateTime = false;
                }

                let validator = this.$refs['commentValidationGroup']? this.$refs['commentValidationGroup'].instance : false;
                if (validator) {
                    validator.reset();
                }
            },
            createTaskData() {

                let validator = this.validateTask();
                if (!validator.isValid) {
                    return;
                }

                var data = new FormData();
                var fileUploader = this.getFileUploader();

                if (fileUploader) {
                    let files = fileUploader.getFiles();
                    if (files.length) {
                        files.forEach((file) => {
                            data.append('files[]', file);
                        });
                    }
                }

                for (var name in this.formModel) {
                    let value = this.formModel[name];

                    if (value instanceof Date && value) {
                        value = value.toISOString();
                    }

                    if (value !== null) {
                        data.append(name, value);
                    }
                }

                this.taskPrintScreen = '';

                if (this.currentDiagnosticsData) {
                    this.taskPrintScreen = this.$refs[this.sEditorRefName].getEditor().saveImage();

                    let diagnosticsData = {};
                    for (var key in this.currentDiagnosticsData) {
                        if (key != 'latestScreenshotDataUrl') {
                            diagnosticsData[key] = this.currentDiagnosticsData[key];
                        }
                    }

                    data.append('DiagnosticsData', JSON.stringify(diagnosticsData));
                    data.append('ScreenshotDateTime', this.latestScreenshotDateTime.toISOString());
                }

                if (this.taskPrintScreen && this.taskPrintScreen.length > 0) {
                    data.append('printscreen', this.fileCreationFromURL(this.taskPrintScreen, 'printscreen.png'));
                }

                taskService.insertWithAttachments(data).then(
                    (result) => {

                        this.$root.$emit("task_data_changed", 'createTask', data);

                        this.$refs[this.sEditorRefName].getEditor().clear();
                        this.currentDiagnosticsData = false;
                        this.latestScreenshotDateTime = false;
                        this.resetForm();
                        this.hidePopup();

                        notify({
                            message: "Feladat sikeresen létrehozva",
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    },
                    (error) => { }
                );
            },
            updateTaskData() {

                let validator = this.validateTask();
                if (!validator.isValid) {
                    return;
                }

                var data = {
                    key: this.task.id,
                    values: JSON.stringify(this.formModel)
                }
                
                taskService.update(data).then(
                    (result) => {

                        this.$root.$emit("task_data_changed", 'updateTask', data);

                        notify({
                            message: "Feladat sikeresen módosítva",
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    },
                    (error) => { }
                );
            },
            sendCommentData() {

                let validator = this.validateComment();
                if (!validator.isValid) {
                    return;
                }

                var data = new FormData();
                var fileUploader = this.getCommentFileUploader();

                if (fileUploader) {
                    let files = fileUploader.getFiles();
                    if (files.length) {
                        files.forEach((file) => {
                            data.append('files[]', file);
                        });
                    }
                }

                for (var name in this.commentModel) {
                    let value = this.commentModel[name];

                    if (value instanceof Date && value) {
                        value = value.toISOString();
                    }

                    if (value !== null) {
                        data.append(name, value);
                    }
                }

                let taskPrintScreen = '';

                if (this.currentDiagnosticsData) {
                    taskPrintScreen = this.$refs[this.commentSEditorRefName].getEditor().saveImage();

                    let diagnosticsData = {};
                    for (var key in this.currentDiagnosticsData) {
                        if (key != 'latestScreenshotDataUrl') {
                            diagnosticsData[key] = this.currentDiagnosticsData[key];
                        }
                    }

                    data.append('DiagnosticsData', JSON.stringify(diagnosticsData));
                    data.append('ScreenshotDateTime', this.latestScreenshotDateTime.toISOString());
                }

                if (taskPrintScreen && taskPrintScreen.length > 0) {
                    data.append('printscreen', this.fileCreationFromURL(taskPrintScreen, 'printscreen.png'));
                }

                taskCommentService.insert(data).then(
                    (result) => {
                        this.$root.$emit("task_data_changed", 'sendComment', data);

                        this.$refs[this.commentSEditorRefName].getEditor().clear();
                        this.currentDiagnosticsData = false;
                        this.latestScreenshotDateTime = false;
                        this.resetCommentForm(true);
                        this.getTaskComments(this.commentModel.TaskId).then(
                            (succes) => {
                                this.scrollToBottom();
                            },
                            (failure) => {
                            }
                        );

                        notify({
                            message: "Bejegyzés sikeresen létrehozva",
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    },
                    (error) => { }
                );
            },
            loadTask(taskId, popupMode, scrollToAfterLoaded) {

                if (!popupMode) {
                    popupMode = 'view';
                }

                if (!scrollToAfterLoaded) {
                    scrollToAfterLoaded = top;
                }

                this.resetForm();

                this.showNewCommentButton = popupMode == 'view';

                // Task betöltése
                taskService.getById(taskId).then(
                    (result) => {

                        this.popupMode = popupMode;

                        this.task = result;
                        for (var name in this.formModel) {
                            let lcName = name.toLowerCase();
                            if (this.task[lcName] !== undefined) {
                                this.formModel[name] = this.task[lcName];
                            }
                        }

                        this.commentModel.TaskId = taskId;

                        // Kommentek betöltése
                        this.getTaskComments(taskId).then(
                            (result) => {

                                // Screenshot betöltése ha készült a task létrehozásnál.
                                let filteredComments = this.comments.filter((elem) => elem.type == CommentTypes.FirstCommentWithAttachment);

                                if (filteredComments.length > 0) {
                                    this.firstComment = filteredComments[0];
                                    let screenshots = this.firstComment.attachments.filter((elem) => {
                                        return elem.type == CommentTypes.FirstCommentWithAttachment;
                                    });

                                    if (screenshots.length) {
                                        taskCommentService.screenshot(screenshots[0].id).then(
                                            (result) => {
                                                this.taskPrintScreen = result;
                                            },
                                            (failure) => { }
                                        );
                                    }
                                }

                                var sEditor = this.$refs[this.commentSEditorRefName];
                                sEditor.setHeight();

                                if (scrollToAfterLoaded == 'bottom') {
                                    this.scrollToBottom();
                                }
                                else {
                                    this.scrollToTop();
                                }

                            },
                            (failure) => { }
                        );

                    },
                    (failure) => { }
                );
            },
            getTaskComments(taskId) {
                return taskCommentService.getByTaskId(taskId).then(
                    (result) => {
                        this.comments = result;
                    },
                    (failure) => { }
                );
            },
            showTaskPopup() {
                if (window.taskPrintScreen !== undefined && window.taskPrintScreen) {
                    this.taskPrintScreen = window.taskPrintScreen;
                }
                else {
                    this.taskPrintScreen = '';
                }
                this.showPopup();
            },
            showPopup() {
                let popup = this.$refs['taskPopup'].instance;
                popup.show();
            },
            hidePopup() {
                this.scrollToTop();
                let popup = this.$refs['taskPopup'].instance;
                popup.hide();
            },
            formFieldDataChanged(e) {
                this.formData = e.component.option("formData");
                if (!this.form) {
                    this.form = e.component;
                }
            },
            fileUploadValueChanged(e) {
                this.files = e.value;
            },
            onJsonChange(value) {
                ;
            },
            fileCreationFromURL(inputURI, fileName, lastModified) {

                var binaryVal;

                // mime extension extraction
                var inputMIME = inputURI.split(',')[0].split(':')[1].split(';')[0];

                // Extract remaining part of URL and convert it to binary value
                if (inputURI.split(',')[0].indexOf('base64') >= 0)
                    binaryVal = atob(inputURI.split(',')[1]);

                // Decoding of base64 encoded string
                else
                    binaryVal = unescape(inputURI.split(',')[1]);

                // write the bytes of the string to a typed array
                var blobArray = new Uint8Array(binaryVal.length);
                for (var i = 0; i < binaryVal.length; i++) {
                    blobArray[i] = binaryVal.charCodeAt(i);
                }

                if (!lastModified) {
                    lastModified = (new Date()).getTime();
                }

                var blob = new Blob([blobArray], {
                    type: inputMIME
                });

                var file = new File([blob], fileName, { type: inputMIME });

                return file;
            },
            fileUploaderPropertyChange(e) {
                if (e.name == 'value' && e.value.length > e.previousValue.length) {
                    this.scrollToBottom();
                }
            },
            commentFileUploaderPropertyChange(e) {
                if (e.name == 'value') {
                    this.scrollToBottom();
                }
            },
            scrollToTop() {

                if (this.$refs['formScrollView'] != undefined) {
                    var scrollView = this.$refs.formScrollView;

                    setTimeout(() => {
                        scrollView.instance.scrollTo(0);
                    }, 500);
                }
            },
            scrollToBottom() {

                if (this.$refs['formScrollView'] != undefined) {
                    var scrollView = this.$refs.formScrollView;

                    setTimeout(() => {
                        scrollView.instance.scrollTo(scrollView.instance.scrollHeight());
                    }, 500);
                }
            },
            getCommentClass(comment) {
                let cssClass = ['task-comment'];
                if (comment.ParentCommentId) cssClass.push('has-parent');
                if (this.currentUser.id == comment.createdBy) cssClass.push('owner');
                return cssClass.join(' ');
            },
            setDiagnosticsDataVisibility(comment) {

            },
            commentHasScreenshot(comment) {

                if (comment.attachments && comment.attachments.length) {
                    let screenshots = comment.attachments.filter((elem) => {
                        return elem.type == CommentTypes.FirstCommentWithAttachment;
                    });
                    if (screenshots.length) {
                        return true;
                    }
                }

                return false;
            },
            getScreenshotFile(comment) {

                if (comment.attachments && comment.attachments.length) {
                    let screenshots = comment.attachments.filter((elem) => {
                        return elem.type == CommentTypes.FirstCommentWithAttachment;
                    });
                    if (screenshots.length) {
                        taskCommentService.screenshot(screenshots[0].id).then(
                            (result) => {
                                let image = document.getElementById('comment-screenshot-img-' + comment.id);
                                image.src = result;
                            },
                            (failure) => { }
                        );

                        return true;
                    }
                }
                return false;
            },
            formatCommentDate(dateString) {
                try {
                    let dArray = dateString.split('T');
                    return dArray[0] + ' ' + (dArray[1].split('.'))[0];
                }
                catch (error) {
                    return dateString;
                }
            },
            formatTitleDate(dateString) {
                try {
                    let dArray = dateString.split('T');
                    return dArray[0];
                }
                catch (error) {
                    return dateString;
                }
            },
            replaceNewlineToBr(text) {
                try {
                    if (text.length) {
                        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                }
                catch (error) {
                    return text;
                }
            },
            filteredAttachments(attachments) {
                return attachments.filter((elem) => elem.type != CommentTypes.FirstCommentWithAttachment);
            },
            getAttachmentIconClass(attachment) {

                let cssClass = '';

                switch (attachment.contentType) {
                    case 'application/pdf':
                        cssClass = 'pdffile';
                        break;
                    case 'application/octet-stream':
                        cssClass = 'file';
                        break;
                    case 'application/vnd.ms-excel':
                        cssClass = 'xlsfile';
                        break;
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        cssClass = 'xlsxfile';
                        break;
                    case 'image/gif':
                    case 'image/jpeg':
                    case 'image/png':
                        cssClass = 'image';
                        break;
                    case 'text/plain':
                        cssClass = 'txtfile';
                        break;
                    case 'application/msword':
                        cssClass = 'docfile';
                        break;
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                        cssClass = 'docxfile';
                        break;
                    default:
                        cssClass = 'file';
                        break;
                }
                return 'dx-icon dx-icon-' + cssClass;
            },
            getAttachmentTitle(attachment) {
                return "Fájlnév: " + attachment.originalFileName + "\r\ntípus: " + attachment.contentType + "\r\nméret: " + this.formatFileSize(attachment.size);
            },
            downloadAttachment(attachment) {
                taskCommentService.attachment(attachment.id).then(
                    (result) => {
                        var a = document.createElement('a');
                        var url = window.URL.createObjectURL(new Blob([result], {
                            type: attachment.contentType
                        }));
                        a.href = url;
                        a.download = attachment.originalFileName;
                        document.body.append(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    },
                    (failure) => { }
                );
            },
            formatFileSize(bytes, si = false, dp = 1) {
                const thresh = si ? 1000 : 1024;

                if (Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }

                const units = si
                    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
                let u = -1;
                const r = 10 ** dp;

                do {
                    bytes /= thresh;
                    ++u;
                } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


                return bytes.toFixed(dp) + ' ' + units[u];
            },
            chooseAction(action) {

                if (action == 'newBugreport') {
                    this.popupMode = 'insert';
                    this.formModel.Type = TaskTypes.BugReport;
                    var sEditor = this.$refs[this.sEditorRefName];
                    sEditor.onScreenshotArrived(this.currentDiagnosticsData.latestScreenshotDataUrl);
                }
                else if (action == 'newImprovementProposals') {
                    this.popupMode = 'insert';
                    this.formModel.Type = TaskTypes.ImprovementProposal;
                    var sEditor = this.$refs[this.sEditorRefName];
                    sEditor.onScreenshotArrived(this.currentDiagnosticsData.latestScreenshotDataUrl);
                }
                else if (action == 'addScreenshotToBugreport') {
                    this.$router.push({ name: 'Bugreports' });
                    var sEditor = this.$refs[this.commentSEditorRefName];
                    sEditor.onScreenshotArrived(this.currentDiagnosticsData.latestScreenshotDataUrl);
                    this.hidePopup();
                }
                else if (action == 'addScreenshotToImprovementProposal') {
                    this.$router.push({ name: 'ImprovementProposals' });
                    var sEditor = this.$refs[this.commentSEditorRefName];
                    sEditor.onScreenshotArrived(this.currentDiagnosticsData.latestScreenshotDataUrl);
                    this.hidePopup();
                }
                else if (action == 'showDevelopmentDiary') {
                    this.$router.push({ name: 'DevelopmentDiary' });
                    var sEditor = this.$refs[this.commentSEditorRefName];
                    sEditor.onScreenshotArrived(this.currentDiagnosticsData.latestScreenshotDataUrl);
                    this.hidePopup();
                }

                let popup = this.$refs['taskPopup'].instance;
                popup.option('maxHeight', this.popupOptions.default.maxHeight);
                popup.option('maxWidth', this.popupOptions.default.maxWidth);
            },
            getDiagnosticsDataCallback(componentTag, jsonDataString) {
                var jsonData = JSON.parse(jsonDataString);

                this.currentDiagnosticsData = jsonData;
                this.latestScreenshotDateTime = new Date(this.currentDiagnosticsData.latestScreenshotDateTime);
            },
            dateTimeFormatter(date, dateOnly) {
                let dtParam = { month: "numeric", day: "numeric", year: "numeric" };

                if (dateOnly !== true) {
                    dtParam['hour'] = 'numeric';
                    dtParam['minute'] = 'numeric';
                    dtParam['second'] = 'numeric';
                }
                var formatter = new Intl.DateTimeFormat('hu-HU', dtParam);
                return formatter.format(date);
            },
            validateTask() {
                let validator = this.$refs['taskValidationGroup'].instance;
                return validator.validate();
            },
            validateComment() {
                let validator = this.$refs['commentValidationGroup'].instance;
                return validator.validate();
            },
            onClickBugReport(e) {
                if (!this.bugReportSpinnerActive) {
                    this.$root.$emit("show_bugreport_popup");
                }
            },
            showConfirmPopup() {
                this.confirmPopupInstance.show();
            },
            deleteScreenshot(isCommentScreenshot) {
                if (isCommentScreenshot) {
                    this.$refs[this.commentSEditorRefName].getEditor().clear();
                }
                else {
                    this.$refs[this.sEditorRefName].getEditor().clear();
                }

                this.confirmPopupInstance.hide();
                this.currentDiagnosticsData = false;
            },
            getFileUploader() {
                return this.$refs[this.fileUploaderRefName];
            },
            getCommentFileUploader() {
                return this.$refs[this.commentFileUploaderRefName];
            }
        },
        mounted() {
            this.$root.$on('activate_bug_spinner', () => {
                this.bugReportSpinnerActive = true;
            });
            this.$root.$on('deactivate_bug_spinner', () => {
                this.bugReportSpinnerActive = false;
            });
        },
        created() {

            this.popupMode = this.mode;

            this.$root.$on('screenshot_is_complete', (data) => {

                this.resetForm();

                this.popupMode = 'chooseAfterScreenshot';

                this.showPopup();

                this.scrollToTop();

                this.currentDiagnosticsData = false;
                this.currentDiagnosticsData = false;

                // A VUE $refs felépítése miatt kell
                let timeout = (this.$refs[this.sEditorRefName] === undefined ? 100 : 0);
                let popup = this.$refs['taskPopup'].instance;
                popup.option('maxHeight', this.popupOptions.choose.maxHeight);
                popup.option('maxWidth', this.popupOptions.choose.maxWidth);

                setTimeout(() => {
                    this.$root.$emit('get_diagnostics_data', this.getDiagnosticsDataCallback);
                }, timeout);
                
            });

            this.$root.$on('new_task', (data) => {
                this.popupResetToDefault();
                this.showPopup();

                this.resetForm();
                this.scrollToTop();
            });

            this.$root.$on('view_task', (data) => {

                this.popupResetToDefault();

                this.showPopup();

                // mindig az aljára pozícionáljuk a scrollbar-t
                let scrollTo = 'bottom';
                this.loadTask(data, 'view', scrollTo);
            });

            this.$root.$on('edit_task', (data) => {
                this.popupResetToDefault();
                this.showPopup();

                // mindig az aljára pozícionáljuk a scrollbar-t
                let scrollTo = 'bottom';
                this.loadTask(data, 'view', scrollTo);// egyelőre NINCS szerkesztés
            });
        },
        computed: {
            createdDate() {
                
                let date;
                
                if (this.popupMode == 'insert' && this.latestScreenshotDateTime) {
                    date = this.latestScreenshotDateTime;
                }
                else if (this.firstComment && this.firstComment.screenshotDateTime) {
                    date = new Date(this.firstComment.screenshotDateTime);
                }
                else if (!(this.formModel.Created_date instanceof Date) && !this.formModel.Created_date.length) {
                    date = new Date();
                }
                else if (!(this.formModel.Created_date instanceof Date)) {
                    date = new Date(this.formModel.Created_date);
                }

                return this.dateTimeFormatter(date);
            },
            showForm() {
                return true;
            },
            taskTypeText() {
                for (var idx in TaskType) {
                    if (TaskType[idx].id == this.formModel.Type) {
                        return TaskType[idx].name;
                    }
                }
                return '';
            },
            filteredComments() {
                // Csak a normál hozzászólásoka listázzuk. 1: első hozzászólás csatolmánnyal, 2: normál hozzászólás
                //return this.comments.filter((item) => item.type != CommentTypes.FirstCommentWithAttachment);
                return this.comments;
            },
            showPriorityAndDates() {
                // egyelőre semmiképp sem jelenítjük meg
                return false;
            },
            popupTitle() {
                if (this.popupMode == 'chooseAfterScreenshot') {
                    return 'Képernyőkép';
                }

                if (this.task && this.task.id) {
                    let date = this.firstComment && this.firstComment.screenshotDateTime ? new Date(this.firstComment.screenshotDateTime) : new Date();
                    return '<div class="popup-header-id-and-title">#' + this.task.id + ' ' + this.task.name + '</div><div class="popup-header-date">(' + this.dateTimeFormatter(date, true) + ')</div>';
                }
                else {
                    return this.taskTypeText + ' - ' + this.createdDate;
                }
            },
            popupInstance() {
                return this.$refs['taskPopup'].instance;
            },
            confirmPopupInstance() {
                return this.$refs['confirmPopup'].instance;
            }
        }
    }
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.content h4 {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 18px;
}

.content {
    margin-top: 50px;
    margin-left: 10px;
    display: none;
}

#task-popup-form .dx-field-label,
#task-popup-comment-form .dx-field-label {
    width: auto;
    float: none;
}

#task-popup-form .dx-field-value,
#task-popup-comment-form .dx-field-value {
    width: auto;
    float: none;
}

.selected-item {
    margin-bottom: 20px;
}

.task-popup-header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.choose-text {
    margin: 0 0 20px;
    text-align: center;
    padding: 0 10px;
}
.choose-buttons {
    padding: 0 10px;
}
.choose-button {
    margin: 0 0 6px;
}

.task-popup-header h3 {
    margin: 0;
}
.comment-screenshot-box,
.task-screenshot-box {
    margin: 10px 0;
}
.comment-screenshot-box .label,
.task-screenshot-box .label {
    font-weight: bold;
}
.btn-delete-screenshot {
    padding: 0 3px;
    opacity: 0.5;
}
.btn-delete-screenshot:hover {
    opacity: 1;
}
/*
.task-screenshot-box .label .dx-link-icon {
    font-weight: normal;
    color: #888888;
    font-size: 14px;
    line-height: 19px;
}
*/
.dx-fieldset.popup-fieldset {
    margin: 0 20px 0;
}
.comment-screenshot-box .flex-container,
.task-screenshot-box .flex-container {
    margin-bottom: 10px;
}
.diagnostics-data {
    margin-bottom: 20px;
}
.diagnostics-data .label {
    font-weight: bold;
    margin-bottom: 6px;
}
.first-comment {
    margin-bottom: 8px;
}
.task-footer {
    text-align: right;
    margin-top: 4px;
    margin-bottom: 10px;
}
.task-comment-list,
.task-comment-form {
    padding: 6px 0;
}
.task-comment-form {
    margin-top: -12px;
}
.comment-buttons {
    text-align: right;
    margin-top: 4px;
    margin-left: 0;
    margin-right: 0;
}
.task-comment {
    margin: 0 0 10px;
    padding: 6px 6px 0;
    background-color: #fafafa;
}
.task-comments-title {
    margin-bottom: 4px;
}
task-attachments {
    margin-top: 6px;
}
.has-no-attachment {
    padding: 0 6px;
    font-size: 80%;
}
.comment-header {
    display: flex;
    flex-direction: row;
    padding: 0 0 3px;
    border-bottom: 1px solid #ffffff;
}
.comment-created-by-name {
    font-weight: bold;
}
.comment-create-date {
    margin-right: 20px;
}
.comment-screenshot-box {
    padding: 4px;
}
.comment-body {
    padding: 20px 0;
}
.comment-screenshot-img {
    max-width: 100%;
    height: auto;
}
.comment-attachment-list {
    padding: 0;
    border-top: 1px solid #ffffff;
}
.comment-attachment-title {
    font-size: 80%;
    opacity: 0.8;
    margin: 4px 0;
    font-weight: bold;
}
.comment-attachment {
    margin: 0 6px 6px 0;
}

.flex-container {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}
.created-date {
    text-align: right;
}
.dx-field-label.comment-label {
    font-weight: bold;
    padding-top: 0;
}
#new-task-attachment,
#new-comment-attachment {
    border: 1px solid #dddddd;
    margin-bottom: 10px;
}
.iconset.bug_report {
    color: #fff;
    font-size: 21px;
}
.spinner .iconset.bug_report {
    opacity: 0.3;
}
/deep/ .custom-fileuploader-files-container {
    padding: 0 0 0 11px;
    margin-top: -9px;
    margin-bottom: -2px;
}
/deep/ .dx-fileuploader-input-wrapper {
    padding: 0;
}
/deep/ .custom-fileuploader-template-wrapper {
    border: 1px solid #dddddd;
    padding: 13px 7px 0px 2px;
    margin-bottom: 10px
}
.task-toolbar-items-container {
    display: flex;
    flex-wrap: nowrap
}
.task-toolbar-before {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    flex-grow: 5;
    display: block;
    height: 36px;
    line-height: 34px;
    font-size: 20px;
    display: flex;
}
.task-toolbar-after {
    flex-grow: 1;
    position: relative;
    display: block;
    height: 36px;
    text-align: right;
    margin-right: -10px;
    min-width: 96px;
}
.task-toolbar-before /deep/ .popup-header-id-and-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}
.task-toolbar-before /deep/ .popup-header-date {
    width: 126px;
    padding-left: 4px;
    display: block;
}
.dx-button-bug {
    margin-right: 16px;
}
.spinner {
    background-position: 0px -1px;
    background-size: 20px 20px;
    background-image: url("/img/icons/spinner.gif") !important;
    background-color: rgba(255, 255, 255, 0) !important;
    transition: none !important;
}

.spinner a i {
    color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 650px) {
    .panel {
        padding: 0;
        width: 100%;
    }
    .task-popup-header {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }
    .flex-container {
        flex-direction: column;
    }
    .created-date {
        text-align: left;
    }
}
</style>
